import { useEffect, useState } from "react";
import InputFormik from "../../../../common/Formik/Input/InputFormik";
import { Link } from "react-router-dom";
import { KycApproveIcon } from "../../../../../assets/icons/svgicons";

import Button from "../../../../common/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getBankDetailsAction, generateWithdrawOTPAction, verifyWithdrawOTPAction, getUserInfoAction, getWalletBalanceAction,
} from "../../../../../features/user/userSlice";
import { STATUS_CODE } from "../../../../../utils/constants";
import * as Yup from "yup";
import { Messages } from "../../../../../utils/constants";
import { FORMIK_REGEX } from "../../../../../utils/constants";
import { validationMessage } from "../../../../../Helper/helperfunction";
import { useFormik } from "formik";
import { formatPrice } from "../../../../../utils/utils";
import style from "./WithdrawFiat.module.scss";
import { ROUTES } from "../../../../../routes";

const WithdrawFiat = ({ portfolioBalance }) => {
  const dispatch = useDispatch();
  const signUpData = useSelector((state) => state?.persist?.signUpData);
  const [bankDetails, setBankDetails] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [loading, setLoading] = useState(false);   // ← This is the main bug fix
  const [userData, setUserData] = useState();
  const [showSuccess, setShowSuccess] = useState(false);

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required(validationMessage("OTP"))
      .matches(FORMIK_REGEX.NUMBER, Messages?.NUMBERVALIDATION),
    amount: Yup.string()
      .required(validationMessage("Amount"))
      .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: "",
      otp: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const withdrawRequestResponse = await dispatch(
          verifyWithdrawOTPAction({
            username: userData?.email,
            service: "WITHDRAW_REQUEST",
            otp: values.otp,
            amount: values.amount,
            bankId: bankDetails?.bank_uuid,
          })
        );
        if (withdrawRequestResponse.status === 200) {
          await dispatch(getWalletBalanceAction());
          resetForm();
          setShowSuccess(true);
          //   handleClose();
          // Optionally handle success or update state
        }
      } catch (error) {
        console.error("Error withdrawing:", error);
        // Optionally handle error
      }
    },
  });

  //   useEffect(() => {
  //     if (show) {
  //       fetchBankDetails();
  //     }
  //   }, [show]);

  const fetchBankDetails = async () => {
    try {
      const response = await dispatch(getBankDetailsAction());
      if (response.data.status === STATUS_CODE.successful) {
        setBankDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
    } finally {
      setLoading(false);
    }
  };

  const hasBankDetails =
    bankDetails &&
    Object.keys(bankDetails).length > 0 &&
    bankDetails?.bank_uuid;


  const getUserProfile = async () => {
    const response = await dispatch(getUserInfoAction());
    if (response?.data?.data) {
      setUserData(response.data.data);
    }
  };

  const handleGenerateOtp = async () => {
    try {
      const response = await dispatch(
        generateWithdrawOTPAction({
          type: "EMAIL",
          service: "WITHDRAW_REQUEST",
          username: userData?.email,
        })
      );
      if (response.data.status === STATUS_CODE.successful) {
        formik.setFieldValue("otp", response.data.data.otp);
      }
    } catch (error) {
      console.error("Error generating OTP:", error);
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      formik.setFieldValue("amount", value);
    }
  };

  //   const handleCancel = () => {
  //     if (!loading) {
  //       handleClose();
  //     }
  //   };

  useEffect(() => {
    fetchBankDetails();
    getUserProfile();
  }, []);
  return (
    <>
      <div className={style.withdrawTab}>
        {showSuccess ? (
          <div className={style.success_screen}>
            <div className={style.deposit_img}>
              <KycApproveIcon />
            </div>
            <h2 className="smallText">Withdrawal Request Received</h2>
            <p>
              Your withdrawal request will be processed within 4 hours as per
              banking process.
            </p>
            <Button
              fluid
              variant="secondary_btn"
              onClick={() => setShowSuccess(false)}
              className={style.submit_btn}
            >
              Done
            </Button>
          </div>
        ) : (
          <>
            <h4>Bank Details</h4>
            <ul className={style.withdrawList}>
              <li>
                <label>Bank Name: </label>
                <h6>{bankDetails?.bank_name}</h6>
              </li>
              <li>
                <label>Account Number:</label>
                <h6>{bankDetails?.account_number}</h6>
              </li>
              <li>
                <label>Routing Number: </label>
                <h6>{bankDetails?.routing_number}</h6>
              </li>
              <li>
                <label>Bank Address: </label>
                <h6>
                  {bankDetails?.bank_uuid &&
                    `${bankDetails.bank_uuid.slice(
                      0,
                      5
                    )}....${bankDetails.bank_uuid.slice(-5)}`}
                </h6>
              </li>
            </ul>
            <div className={style.forminput}>
              <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <div className={style.amoutData}>
                  <InputFormik
                    className={style.amountField}
                    name="amount"
                    variant="large_height"
                    placeholder="Enter Amount"
                    value={formik.values.amount}
                    onChange={handleAmountChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.amount && formik.errors.amount}
                  />
                  <p>
                    {" "}
                    Total Balance :
                    <span>
                      {" "}
                      {formatPrice(Number(portfolioBalance))} USD STBL
                    </span>{" "}
                  </p>
                </div>
                <div className={style.otp_container}>
                  <InputFormik
                    className={style.otpField}
                    name="otp"
                    variant="large_height"
                    placeholder="Enter OTP"
                    value={formik.values.otp}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.otp && formik.errors.otp}
                  />
                  <Button
                    className={style.generate_otp_btn}
                    variant="small_size text_blue"
                    onClick={handleGenerateOtp}
                  >
                    Generate OTP
                  </Button>
                </div>
                {!hasBankDetails && (
                  <p className={`mb-3 ${style.no_bank_text}`}>
                    Please add bank details to withdraw funds.{" "}
                    <Link
                      to={`${ROUTES.MY_PROFILE}#bank-details`}
                      className={style.add_bank_link}
                    >
                      Add Bank Details
                    </Link>
                  </p>
                )}

                <Button
                  fluid
                  className={style.buy_btn}
                  variant="secondary_btn"
                  type="button"
                  disabled={
                    !hasBankDetails || !formik.values.amount || !formik.values.otp
                  }
                  onClick={(e) => {
                    formik.handleSubmit(e);
                  }}
                >
                  Withdraw
                </Button>
              </form>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default WithdrawFiat;
